<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="班级名称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.className"
          ></a-input>
        </a-form-item>
        <a-form-item label="年级">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.gradeId"
          >
            <a-select-option
              v-for="(item, index) in schoolGradeList"
              :key="index"
              :value="item.gradeTagId"
              >{{ item.gradeName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <!-- 学校 -->
        <c-school-select
          :schoolCode.sync="queryParam.schoolId"
        ></c-school-select>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchOriginalClass()"
            >查询</a-button
          >
          <a-button @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper">
      <a-button
        type="primary"
        icon="plus"
        @click="$refs.originalClassForm.init('add')"
        >新建</a-button
      >
      <div class="import-excel">
        <a-button
          type="primary"
          icon="plus"
          @click="$refs.sourceClassFile.init()"
          >导入原始班级</a-button
        >
      </div>
      <a-button
        type="primary"
        class="select-row"
        v-if="openAllIndex == '0'"
        @click="openAllIndex = '1'"
        >批量删除</a-button
      >
      <template v-if="openAllIndex == '1'">
        <a-button type="primary" class="select-row" @click="deleteSelectRow()"
          >删除</a-button
        >
        <a-button type="primary" class="select-row" @click="openAllIndex = '0'"
          >取消</a-button
        >
      </template>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="originalClassList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      rowKey="id"
      :rowSelection="openAllIndex != '0' ? rowSelection : null"
    >
      <span slot="gender" slot-scope="text, record">
        <template>
          <span>{{ record.gender | gender }}</span>
        </template>
      </span>
      <span slot="gradeId" slot-scope="text, record">
        <template>
          <span>{{ record.gradeId | gradeScopeFilter }}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a
            @click="
              $router.push({
                name: 'studentList',
                params: { classId: record.id },
              })
            "
            >查看学生报名</a
          >
          <a-divider type="vertical" />
          <a @click="$refs.originalClassForm.init('update', record)">修改</a>
        </template>
      </span>
    </a-table>
    <source-class-form-modal
      ref="originalClassForm"
      @addOriginalClass="addOriginalClass"
      @updateOriginalClass="updateOriginalClass"
    ></source-class-form-modal>

    <source-class-file-modal
      ref="sourceClassFile"
      @refreshList="getOriginalClassList()"
    ></source-class-file-modal>
  </div>
</template>
<script>
import sourceClass from '../../api/sourceClass'

import sourceClassFormModal from './SourceClassFormModal'

import { analysisAddress } from '../../utils/address'

import CSchoolSelect from '../../components/CSchoolSelect'

import SourceClassFileModal from './components/SourceClassFileModal'

import school from '../../api/school'

import Vue from 'vue'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: '班级名称',
    dataIndex: 'className',
  },
  {
    title: '年级',
    dataIndex: 'gradeId',
    scopedSlots: { customRender: 'gradeId' },
    width: 80,
  },
  {
    title: '学校名称',
    dataIndex: 'schoolName',
  },
  {
    title: '班主任',
    dataIndex: 'headteacherName',
  },
  {
    title: '班主任电话',
    dataIndex: 'headteacherMobile',
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'sourceClass',
  data() {
    return {
      originalClassList: [], //原始班级数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      loading: true,
      searchSchoolLoading: false, //搜索学校loading
      schoolList: [], //学校list
      schoolGradeList:Vue.ls.get('schoolGrade'),
      openAllIndex: '0', //是否开启全部选择
      selectedRowKeys: [], //table选中的项目list
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  components: {
    SourceClassFileModal,
    sourceClassFormModal,
    CSchoolSelect,
  },
  methods: {
    //表格删除选中的学生
    deleteSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选删除项')
        return
      }
      sourceClass
        .batchDelete({ ids: this.selectedRowKeys.join() })
        .then((res) => {
          this.$message.success('删除成功')
          this.getOriginalClassList()
          this.selectedRowKeys = []
        })
    },

    //搜索学校
    searchSchool(val = '') {
      this.searchSchoolLoading = true
      school.searchSchool({ schoolName: val }).then((res) => {
        this.searchSchoolLoading = false
        this.schoolList = res.data
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getOriginalClassList(obj)
    },

    //新增一个原始班级
    addOriginalClass(sourceClass) {
      this.originalClassList.unshift(sourceClass)
    },
    updateOriginalClass(sourceClass) {
      if(this.originalClassList && this.originalClassList.length) {
        for (var i = 0;i<this.originalClassList.length;i++) {
          if (this.originalClassList[i].id==sourceClass.id) {
            this.originalClassList.splice(i, 1, sourceClass);
            break;
          }
        }
      }
    },

    //查询原始班级
    searchOriginalClass() {
      this.queryParam.currentPage = 1
      this.queryParam.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      this.getOriginalClassList(this.queryParam)
    },

    //原始班级列表
    getOriginalClassList(params) {
      this.loading = true
      sourceClass.getOriginalClassList(params).then((res) => {
        console.log('当前的原始班级列表是', res.data.list)
        this.originalClassList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then(async (res) => {
        //只有才有权限
        this.roleId = res.accRole.id.toString()
        //平台管理员
        if (this.roleId == '6') {
          if (!this.$route.query.params) {
            await school.searchSchool({ schoolName: '' }).then((res) => {
              this.queryParam.schoolId = res.data[0].id
            })
          }
        }
        this.getOriginalClassList(this.queryParam)
      })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.searchSchool()
    this.judgeIsOper()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
  > .item {
    display: inline-block;
    margin-left: 20px;
  }
}
.price-scope {
  width: 100px;
  text-align: center;
}
.max-price {
  border-left: none;
}
.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;
}
</style>
